import InfoSolidSVG from "@design-system/ui-icons/vanilla/InfoSolid"
import { createIcon } from "../createIcon"

export const InfoSolidIcon = createIcon(InfoSolidSVG)
